var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon011(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00049 5V7.66667M8.00049 10.3333H8.00715M7.07737 1.59448L1.59411 11.0656C1.28997 11.5909 1.1379 11.8536 1.16038 12.0691C1.17998 12.2572 1.2785 12.428 1.4314 12.5392C1.60671 12.6667 1.91022 12.6667 2.51723 12.6667H13.4837C14.0908 12.6667 14.3943 12.6667 14.5696 12.5392C14.7225 12.428 14.821 12.2572 14.8406 12.0691C14.8631 11.8536 14.711 11.5909 14.4069 11.0656L8.92361 1.59448C8.62056 1.07104 8.46904 0.809319 8.27135 0.721416C8.09892 0.644741 7.90206 0.644741 7.72962 0.721416C7.53194 0.809319 7.38041 1.07104 7.07737 1.59448Z",
    stroke: "#9E2B25",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon011);
export default __webpack_public_path__ + "static/media/icon011.e196958ab106c09d9a2a0e7efdd9d82e.svg";
export { ForwardRef as ReactComponent };